import { useIsDesktopRtfCopyEnabled } from '@/features/flags/desktop-rtf-copy';
import { getRtfClipboardCapabilities } from '@/tauri/controller/clipboard';
import { isTauri } from '@/tauri/utils';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { rtfCopyStateAtom, rtfCopyStore, setRtfCopyCapability } from './rtf-copy-state';

/**
 * Checks and tracks native RTF clipboard capability on sign-in without
 * requiring any menu to open.  Called by `useRtfCopyIdentity`; not consumed
 * by any UI now that the per-account toggle has been removed.
 */
export function useRtfCopy(): void {
  const flag = useIsDesktopRtfCopyEnabled();
  const active = isTauri() && flag;
  const state = useAtomValue(rtfCopyStateAtom, {
    store: rtfCopyStore,
  });
  const ownerId = state.ownerId;

  useEffect(() => {
    if (!active) {
      if (ownerId !== null) setRtfCopyCapability(ownerId, 'unknown');
      return;
    }
    if (ownerId === null) return;
    let cancelled = false;
    void getRtfClipboardCapabilities().then(
      (capability) => {
        if (!cancelled) {
          setRtfCopyCapability(
            ownerId,
            capability.supported ? 'supported' : 'unavailable'
          );
        }
      },
      () => {
        if (!cancelled) setRtfCopyCapability(ownerId, 'unavailable');
      }
    );
    return () => {
      cancelled = true;
    };
  }, [active, ownerId]);
}
